// extracted by mini-css-extract-plugin
export default {"productName":"ExternalProductList_productName__5+XMj"};